export const API_PORTAL_URL = process.env.NEXT_PUBLIC_API_URL || "";
export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || "";
export const RAZORPAY_KEY_ID = process.env
  .NEXT_PUBLIC_RAZORPAY_KEY_ID as string;

export const IS_DEMO =
  process.env.NEXT_PUBLIC_APP_ENV === "development" ||
  process.env.APP_ENV === "development" ||
  process.env.NODE_ENV === "development" ||
  process.env.NEXT_PUBLIC_ENABLE_SITEMAP === "false" ||
  process.env.ENABLE_SITEMAP === "false" ||
  process.env.GENERATE_SITEMAP === "false" ||
  process.env.NEXT_PUBLIC_GENERATE_SITEMAP === "false" ||
  SITE_URL.includes("novotrips") ||
  API_PORTAL_URL.includes("novotrips");
